function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import { ELEMENT_DEFAULT, getRangeFromBlockStart, someNode, getText, getRangeBefore, setNodes, getPointBefore, removeMark, isCollapsed } from '@udecode/plate-common';
import { getPlatePluginWithOverrides } from '@udecode/plate-core';
import { Editor, Transforms } from 'slate';

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray_1 = isArray;

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray_1(value) ? value : [value];
}
var castArray_1 = castArray;
var getMatchRange = function getMatchRange(_ref) {
  var match = _ref.match,
    trigger = _ref.trigger;
  var start;
  var end;
  if (_typeof(match) === 'object') {
    start = match.start;
    end = match.end;
  } else {
    start = match;
    end = start.split('').reverse().join('');
  }
  var triggers = trigger ? castArray_1(trigger) : [end.slice(-1)];
  end = trigger ? end : end.slice(0, -1);
  return {
    start: start,
    end: end,
    triggers: triggers
  };
};
var autoformatBlock = function autoformatBlock(editor, _ref2) {
  var text = _ref2.text,
    trigger = _ref2.trigger,
    _match = _ref2.match,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? ELEMENT_DEFAULT : _ref2$type,
    _ref2$allowSameTypeAb = _ref2.allowSameTypeAbove,
    allowSameTypeAbove = _ref2$allowSameTypeAb === void 0 ? false : _ref2$allowSameTypeAb,
    preFormat = _ref2.preFormat,
    format = _ref2.format,
    _ref2$triggerAtBlockS = _ref2.triggerAtBlockStart,
    triggerAtBlockStart = _ref2$triggerAtBlockS === void 0 ? true : _ref2$triggerAtBlockS;
  var matches = castArray_1(_match);
  var _iterator = _createForOfIteratorHelper(matches),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var match = _step.value;
      var _getMatchRange = getMatchRange({
          match: {
            start: '',
            end: match
          },
          trigger: trigger
        }),
        end = _getMatchRange.end,
        triggers = _getMatchRange.triggers;
      if (!triggers.includes(text)) continue;
      var matchRange = void 0;
      if (triggerAtBlockStart) {
        matchRange = getRangeFromBlockStart(editor); // Don't autoformat if there is void nodes.

        var hasVoidNode = someNode(editor, {
          at: matchRange,
          match: function match(n) {
            return Editor.isVoid(editor, n);
          }
        });
        if (hasVoidNode) continue;
        var textFromBlockStart = getText(editor, matchRange);
        if (end !== textFromBlockStart) continue;
      } else {
        matchRange = getRangeBefore(editor, editor.selection, {
          matchString: end
        });
        if (!matchRange) continue;
      }
      if (!allowSameTypeAbove) {
        // Don't autoformat if already in a block of the same type.
        var isBelowSameBlockType = someNode(editor, {
          match: {
            type: type
          }
        });
        if (isBelowSameBlockType) continue;
      }
      Transforms["delete"](editor, {
        at: matchRange
      });
      preFormat === null || preFormat === void 0 ? void 0 : preFormat(editor);
      if (!format) {
        setNodes(editor, {
          type: type
        }, {
          match: function match(n) {
            return Editor.isBlock(editor, n);
          }
        });
      } else {
        format(editor);
      }
      return true;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
};
var isPreviousCharacterEmpty = function isPreviousCharacterEmpty(editor, at) {
  var range = getRangeBefore(editor, at);
  if (range) {
    var text = getText(editor, range);
    if (text) {
      var noWhiteSpaceRegex = new RegExp("\\S+");
      return !text.match(noWhiteSpaceRegex);
    }
  }
  return true;
};
var getMatchPoints = function getMatchPoints(editor, _ref3) {
  var start = _ref3.start,
    end = _ref3.end;
  var selection = editor.selection;
  var beforeEndMatchPoint = selection.anchor;
  if (end) {
    beforeEndMatchPoint = getPointBefore(editor, selection, {
      matchString: end
    });
    if (!beforeEndMatchPoint) return;
  }
  var afterStartMatchPoint;
  var beforeStartMatchPoint;
  if (start) {
    afterStartMatchPoint = getPointBefore(editor, beforeEndMatchPoint, {
      matchString: start,
      skipInvalid: true,
      afterMatch: true
    });
    if (!afterStartMatchPoint) return;
    beforeStartMatchPoint = getPointBefore(editor, beforeEndMatchPoint, {
      matchString: start,
      skipInvalid: true
    });
    if (!isPreviousCharacterEmpty(editor, beforeStartMatchPoint)) return;
  }
  return {
    afterStartMatchPoint: afterStartMatchPoint,
    beforeStartMatchPoint: beforeStartMatchPoint,
    beforeEndMatchPoint: beforeEndMatchPoint
  };
};
var autoformatMark = function autoformatMark(editor, _ref4) {
  var type = _ref4.type,
    text = _ref4.text,
    trigger = _ref4.trigger,
    _match = _ref4.match,
    ignoreTrim = _ref4.ignoreTrim;
  if (!type) return false;
  var selection = editor.selection;
  var matches = castArray_1(_match);
  var _iterator2 = _createForOfIteratorHelper(matches),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var match = _step2.value;
      var _getMatchRange2 = getMatchRange({
          match: match,
          trigger: trigger
        }),
        start = _getMatchRange2.start,
        end = _getMatchRange2.end,
        triggers = _getMatchRange2.triggers;
      if (!triggers.includes(text)) continue;
      var matched = getMatchPoints(editor, {
        start: start,
        end: end
      });
      if (!matched) continue;
      var afterStartMatchPoint = matched.afterStartMatchPoint,
        beforeEndMatchPoint = matched.beforeEndMatchPoint,
        beforeStartMatchPoint = matched.beforeStartMatchPoint;
      var matchRange = {
        anchor: afterStartMatchPoint,
        focus: beforeEndMatchPoint
      };
      if (!ignoreTrim) {
        var matchText = getText(editor, matchRange);
        if (matchText.trim() !== matchText) continue;
      } // delete end match

      if (end) {
        Transforms["delete"](editor, {
          at: {
            anchor: beforeEndMatchPoint,
            focus: selection.anchor
          }
        });
      }
      var marks = castArray_1(type); // add mark to the text between the matches

      Transforms.select(editor, matchRange);
      marks.forEach(function (mark) {
        editor.addMark(mark, true);
      });
      Transforms.collapse(editor, {
        edge: 'end'
      });
      removeMark(editor, {
        key: marks,
        shouldChange: false
      });
      Transforms["delete"](editor, {
        at: {
          anchor: beforeStartMatchPoint,
          focus: afterStartMatchPoint
        }
      });
      return true;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return false;
};
var autoformatText = function autoformatText(editor, _ref5) {
  var text = _ref5.text,
    _match = _ref5.match,
    trigger = _ref5.trigger,
    format = _ref5.format;
  var selection = editor.selection;
  var matches = castArray_1(_match); // dup
  var _iterator3 = _createForOfIteratorHelper(matches),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var match = _step3.value;
      var _getMatchRange3 = getMatchRange({
          match: Array.isArray(format) ? match : {
            start: '',
            end: match
          },
          trigger: trigger
        }),
        start = _getMatchRange3.start,
        end = _getMatchRange3.end,
        triggers = _getMatchRange3.triggers;
      if (!triggers.includes(text)) continue;
      var matched = getMatchPoints(editor, {
        start: start,
        end: end
      });
      if (!matched) continue;
      var afterStartMatchPoint = matched.afterStartMatchPoint,
        beforeEndMatchPoint = matched.beforeEndMatchPoint,
        beforeStartMatchPoint = matched.beforeStartMatchPoint;
      if (end) {
        Transforms["delete"](editor, {
          at: {
            anchor: beforeEndMatchPoint,
            focus: selection.anchor
          }
        });
      }
      if (typeof format === 'function') {
        format(editor, matched);
      } else {
        var formatEnd = Array.isArray(format) ? format[1] : format;
        editor.insertText(formatEnd);
        if (beforeStartMatchPoint) {
          var formatStart = Array.isArray(format) ? format[0] : format;
          Transforms["delete"](editor, {
            at: {
              anchor: beforeStartMatchPoint,
              focus: afterStartMatchPoint
            }
          });
          Transforms.insertText(editor, formatStart, {
            at: beforeStartMatchPoint
          });
        }
      }
      return true;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return false;
};

/**
 * Enables support for autoformatting actions.
 * Once a match rule is validated, it does not check the following rules.
 */
var withAutoformat = function withAutoformat(_ref6) {
  var rules = _ref6.rules;
  return function (editor) {
    var insertText = editor.insertText;
    editor.insertText = function (text) {
      if (!isCollapsed(editor.selection)) return insertText(text);
      var _iterator4 = _createForOfIteratorHelper(rules),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var rule = _step4.value;
          var _autoformatter$mode;
          var _rule$mode = rule.mode,
            mode = _rule$mode === void 0 ? 'text' : _rule$mode,
            insertTrigger = rule.insertTrigger,
            query = rule.query;
          if (query && !query(editor, _objectSpread(_objectSpread({}, rule), {}, {
            text: text
          }))) continue;
          var autoformatter = {
            block: autoformatBlock,
            mark: autoformatMark,
            text: autoformatText
          };
          if ((_autoformatter$mode = autoformatter[mode]) !== null && _autoformatter$mode !== void 0 && _autoformatter$mode.call(autoformatter, editor, _objectSpread(_objectSpread({}, rule), {}, {
            text: text
          }))) {
            return insertTrigger && insertText(text);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      insertText(text);
    };
    return editor;
  };
};
/**
 * @see {@link withAutoformat}
 */

var createAutoformatPlugin = getPlatePluginWithOverrides(withAutoformat);
var autoformatArrow = [{
  mode: 'text',
  match: '->',
  format: '→'
}, {
  mode: 'text',
  match: '<-',
  format: '←'
}, {
  mode: 'text',
  match: '=>',
  format: '⇒'
}, {
  mode: 'text',
  match: ['<=', '≤='],
  format: '⇐'
}];
var autoformatLegal = [{
  mode: 'text',
  match: ['(tm)', '(TM)'],
  format: '™'
}, {
  mode: 'text',
  match: ['(r)', '(R)'],
  format: '®'
}, {
  mode: 'text',
  match: ['(c)', '(C)'],
  format: '©'
}];
var autoformatLegalHtml = [{
  mode: 'text',
  match: '&trade;',
  format: '™'
}, {
  mode: 'text',
  match: '&reg;',
  format: '®'
}, {
  mode: 'text',
  match: '&copy;',
  format: '©'
}, {
  mode: 'text',
  match: '&sect;',
  format: '§'
}];
var autoformatPunctuation = [{
  mode: 'text',
  match: '--',
  format: "\u2014"
}, {
  mode: 'text',
  match: '...',
  format: '…'
}, {
  mode: 'text',
  match: '>>',
  format: '»'
}, {
  mode: 'text',
  match: '<<',
  format: '«'
}];
var autoformatSmartQuotes = [{
  mode: 'text',
  match: '"',
  format: ['“', '”']
}, {
  mode: 'text',
  match: "'",
  format: ['‘', '’']
}];
var autoformatComparison = [{
  mode: 'text',
  match: '!>',
  format: '≯'
}, {
  mode: 'text',
  match: '!<',
  format: '≮'
}, {
  mode: 'text',
  match: '>=',
  format: '≥'
}, {
  mode: 'text',
  match: '<=',
  format: '≤'
}, {
  mode: 'text',
  match: '!>=',
  format: '≱'
}, {
  mode: 'text',
  match: '!<=',
  format: '≰'
}];
var autoformatEquality = [{
  mode: 'text',
  match: '!=',
  format: '≠'
}, {
  mode: 'text',
  match: '==',
  format: '≡'
}, {
  mode: 'text',
  match: ['!==', '≠='],
  format: '≢'
}, {
  mode: 'text',
  match: '~=',
  format: '≈'
}, {
  mode: 'text',
  match: '!~=',
  format: '≉'
}];
var autoformatFraction = [{
  mode: 'text',
  match: '1/2',
  format: '½'
}, {
  mode: 'text',
  match: '1/3',
  format: '⅓'
}, {
  mode: 'text',
  match: '1/4',
  format: '¼'
}, {
  mode: 'text',
  match: '1/5',
  format: '⅕'
}, {
  mode: 'text',
  match: '1/6',
  format: '⅙'
}, {
  mode: 'text',
  match: '1/7',
  format: '⅐'
}, {
  mode: 'text',
  match: '1/8',
  format: '⅛'
}, {
  mode: 'text',
  match: '1/9',
  format: '⅑'
}, {
  mode: 'text',
  match: '1/10',
  format: '⅒'
}, {
  mode: 'text',
  match: '2/3',
  format: '⅔'
}, {
  mode: 'text',
  match: '2/5',
  format: '⅖'
}, {
  mode: 'text',
  match: '3/4',
  format: '¾'
}, {
  mode: 'text',
  match: '3/5',
  format: '⅗'
}, {
  mode: 'text',
  match: '3/8',
  format: '⅜'
}, {
  mode: 'text',
  match: '4/5',
  format: '⅘'
}, {
  mode: 'text',
  match: '5/6',
  format: '⅚'
}, {
  mode: 'text',
  match: '5/8',
  format: '⅝'
}, {
  mode: 'text',
  match: '7/8',
  format: '⅞'
}];
var autoformatDivision = [{
  mode: 'text',
  match: '//',
  format: '÷'
}];
var autoformatOperation = [{
  mode: 'text',
  match: '+-',
  format: '±'
}, {
  mode: 'text',
  match: '%%',
  format: '‰'
}, {
  mode: 'text',
  match: ['%%%', '‰%'],
  format: '‱'
}].concat(autoformatDivision);
var autoformatSubscriptNumbers = [{
  mode: 'text',
  match: '~0',
  format: '₀'
}, {
  mode: 'text',
  match: '~1',
  format: '₁'
}, {
  mode: 'text',
  match: '~2',
  format: '₂'
}, {
  mode: 'text',
  match: '~3',
  format: '₃'
}, {
  mode: 'text',
  match: '~4',
  format: '₄'
}, {
  mode: 'text',
  match: '~5',
  format: '₅'
}, {
  mode: 'text',
  match: '~6',
  format: '₆'
}, {
  mode: 'text',
  match: '~7',
  format: '₇'
}, {
  mode: 'text',
  match: '~8',
  format: '₈'
}, {
  mode: 'text',
  match: '~9',
  format: '₉'
}];
var autoformatSubscriptSymbols = [{
  mode: 'text',
  match: '~+',
  format: '₊'
}, {
  mode: 'text',
  match: '~-',
  format: '₋'
}];
var autoformatSuperscriptNumbers = [{
  mode: 'text',
  match: '^0',
  format: '⁰'
}, {
  mode: 'text',
  match: '^1',
  format: '¹'
}, {
  mode: 'text',
  match: '^2',
  format: '²'
}, {
  mode: 'text',
  match: '^3',
  format: '³'
}, {
  mode: 'text',
  match: '^4',
  format: '⁴'
}, {
  mode: 'text',
  match: '^5',
  format: '⁵'
}, {
  mode: 'text',
  match: '^6',
  format: '⁶'
}, {
  mode: 'text',
  match: '^7',
  format: '⁷'
}, {
  mode: 'text',
  match: '^8',
  format: '⁸'
}, {
  mode: 'text',
  match: '^9',
  format: '⁹'
}];
var autoformatSuperscriptSymbols = [{
  mode: 'text',
  match: '^o',
  format: '°'
}, {
  mode: 'text',
  match: '^+',
  format: '⁺'
}, {
  mode: 'text',
  match: '^-',
  format: '⁻'
}];
var autoformatMath = [].concat(autoformatComparison, autoformatEquality, _toConsumableArray(autoformatOperation), autoformatFraction, autoformatSuperscriptSymbols, autoformatSubscriptSymbols, autoformatSuperscriptNumbers, autoformatSubscriptNumbers);
export { autoformatArrow, autoformatBlock, autoformatComparison, autoformatDivision, autoformatEquality, autoformatFraction, autoformatLegal, autoformatLegalHtml, autoformatMark, autoformatMath, autoformatOperation, autoformatPunctuation, autoformatSmartQuotes, autoformatSubscriptNumbers, autoformatSubscriptSymbols, autoformatSuperscriptNumbers, autoformatSuperscriptSymbols, autoformatText, createAutoformatPlugin, getMatchPoints, getMatchRange, isPreviousCharacterEmpty, withAutoformat };